function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Flag",
  transform: "translate(-4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_830",
  "data-name": "Path 830",
  d: "M14.933,1.6H10.4V.939C10.4.369,10.086,0,9.6,0H4.267A.267.267,0,0,0,4,.267V15.733a.267.267,0,1,0,.533,0V8H9.6c.067,0,.4.015.4.319a.257.257,0,0,0,.02.1.867.867,0,0,0,.913.646h4A.267.267,0,0,0,15.2,8.8V1.867A.267.267,0,0,0,14.933,1.6Z",
  fill: "currentColor"
}));

var SvgFlag = function SvgFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.2,
    height: 16,
    viewBox: "0 0 11.2 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Flag.49dc1def.svg";
export { ForwardRef as ReactComponent };